import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageContext } from "../../../../common/message";
import { cleanJoin, cutShort } from "../../../../utils/stringUtil";
import { UPLOAD_STATUS } from "./DocumentUpload";
import Box from "../../../../common/box/Box";
import { getAccessToken } from "../../../../common/authorization/AuthorizeService";
import { isMobile } from "../../../../utils/screenUtil";

function DocumentUploadProgress({ doc, dispatchUpdateAction }) {
  const message = useContext(MessageContext);
  const [displayProgress, setDisplayProgress] = useState(false);
  const [displayRemoveAttachment, setDisplayRemoveAttachment] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setDisplayProgress(
      doc.uploadStatus === UPLOAD_STATUS.IN_PROGRESS || doc.uploadStatus === UPLOAD_STATUS.ERROR
    );
    setDisplayRemoveAttachment(doc.uploadStatus === UPLOAD_STATUS.SUCCESS);
  }, [doc.uploadStatus]);

  return (
    <Box
      isBorderless={true}
      defaultPadding={false}
      className={cleanJoin(
        "has-text-weight-bold",
        displayRemoveAttachment ? "p-0 has-background-white-ter" : "p-0",
        doc.uploadStatus === UPLOAD_STATUS.NOT_STARTED ? "is-hidden" : "",
        "is-flex",
        doc.required ? "mt-3 ml-1" : "mt-1 ml-1"
      )}
    >
      <div className="column">
        {doc.uploadStatus !== UPLOAD_STATUS.NOT_STARTED && (
          <button
            className={cleanJoin(
              "button",
              " has-text-weight-bold",
              " is-light",
              " has-background-white-ter",
              isMobile() ? "is-size-7 mt-3" : "is-size-7"
            )}
            rel="noopener noreferrer"
            // href={doc.href}
            target="_blank"
            onClick={async () => {
              message.toggle({
                show: true,
                title: "",
                content: t("requests.overview.submitted.wait.label"),
                hideNo: true,
                hideYes: true,
                isWait: true,
                hideX: false,
              });
              if (doc.uploadStatus === UPLOAD_STATUS.SUCCESS && doc?.href) {
                fetch(`${process.env.REACT_APP_GATEWAY_URL}${doc.href}`, {
                  method: "GET",
                  headers: {
                    "Request-Origin": "portal",
                    Authorization: "Bearer " + (await getAccessToken()),
                  },
                  mode: "cors",
                  credentials: "include",
                })
                  .then((response) => response.blob())
                  .then(
                    (file) =>
                      window.open(URL.createObjectURL(file)) && message.toggle({ show: false })
                  );
              }
            }}
          >
            {cutShort(doc.file.name, 30, "...")}
          </button>
        )}
      </div>
      {displayRemoveAttachment && (
        <div className="column" style={{ zIndex: 10 }}>
          <FontAwesomeIcon
            size={isMobile() ? "1x" : "2x"}
            onClick={() => {
              message.toggle({
                title: t("requests.submission.upload.deleteAttachmentMessageTitle"),
                content: t("requests.submission.upload.deleteAttachmentMessage"),
                onNo: () => message.toggle({}),
                onYes: () => {
                  doc.uploadStatus = UPLOAD_STATUS.NOT_STARTED;
                  doc.uploadError = null;
                  doc.uploadProgress = 0;
                  doc.file = null;
                  doc.href = null;

                  dispatchUpdateAction();

                  message.toggle({});
                },
              });
            }}
            className={
              isMobile()
                ? "is-pulled-right mt-1 ml-6 is-clickable"
                : "is-pulled-right mt-1 ml-3 is-clickable"
            }
            icon={faTimes}
            title={t("requests.submission.upload.deleteAttachment")}
          />
        </div>
      )}
      {displayProgress && (
        <progress className={isMobile() ? "" : "ml-2"} value={doc.uploadProgress} max="100" />
      )}
    </Box>
  );
}

export default DocumentUploadProgress;
